import { GET } from '../request'

export const getAsignaturas = () =>
  GET('/api/agora/planificacion/asignatura/list')
